import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

let apiToken = JSON.parse(localStorage.getItem("authUser"))

export const addProfilePhotoAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser")) 
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    
    const response = await axios.post(`${apiBaseUrl}/update-user-avatar`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding profile photo:", error);
    throw error;
  }
}



